export default {"src":"/_next/static/media/rtg-logo.7a91b7a8.svg","height":70,"width":340,"blurWidth":0,"blurHeight":0};